<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div v-if="!loading.isLoading">
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog as="div" class="relative z-50 lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                                 enter-from="opacity-0" enter-to="opacity-100"
                                 leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
                                 leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-900/80"/>
                </TransitionChild>

                <div class="fixed inset-0 flex">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                                     enter-from="-translate-x-full" enter-to="translate-x-0"
                                     leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                                     leave-to="-translate-x-full">
                        <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
                            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                             enter-to="opacity-100" leave="ease-in-out duration-300"
                                             leave-from="opacity-100" leave-to="opacity-0">
                                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                                    <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                                        <span class="sr-only">Close sidebar</span>
                                        <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true"/>
                                    </button>
                                </div>
                            </TransitionChild>
                            <!-- Sidebar component, swap this element with another sidebar if you like -->
                            <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2">
                                <div class="flex h-16 shrink-0 items-center">
                                    <a href="./">
                                        <img class="h-8 w-auto"
                                             src="/public/misc/logos/logo.svg"
                                             alt="Smartdots"/>
                                    </a>
                                </div>
                                <nav class="flex flex-1 flex-col">
                                    <ul role="list" class="flex flex-1 flex-col gap-y-7">
                                        <li>
                                            <ul role="list" class="-mx-2 space-y-1">
                                                <li v-for="item in navigation" :key="item.name">
                                                    <a :href="item.href"
                                                       :class="[item.current ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50', 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold']">
                                                        <component :is="item.icon"
                                                                   :class="[item.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'h-6 w-6 shrink-0']"
                                                                   aria-hidden="true"/>
                                                        {{ item.name }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <div class="text-xs font-semibold leading-6 text-gray-400">Настройки</div>
                                            <ul role="list" class="-mx-2 mt-2 space-y-1">
                                                <li v-for="team in settings" :key="team.name">
                                                    <a :href="team.href"
                                                       :class="[team.current ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50', 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold']">
                                                        <component :is="team.icon"
                                                                   :class="[team.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'h-6 w-6 shrink-0']"
                                                                   aria-hidden="true"/>
                                                        <span class="truncate">{{ team.name }}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div class="hidden lg:fixed lg:inset-y-0 lg:z-40 lg:flex lg:w-72 lg:flex-col">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6">
                <div class="flex h-16 shrink-0 items-center">
                    <a href="./">
                        <img class="h-8 w-auto"
                             src="/public/misc/logos/logo.svg"
                             alt="Smartdots"/>
                    </a>
                </div>
                <nav class="flex flex-1 flex-col">
                    <ul role="list" class="flex flex-1 flex-col gap-y-7">
                        <li>
                            <ul role="list" class="-mx-2 space-y-1">
                                <li v-for="item in navigation" :key="item.name">
                                    <a :href="item.href"
                                       :class="[item.current ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50', 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold']">
                                        <component :is="item.icon"
                                                   :class="[item.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'h-6 w-6 shrink-0']"
                                                   aria-hidden="true"/>
                                        {{ item.name }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <div class="text-xs font-semibold leading-6 text-gray-400">Настройки</div>
                            <ul role="list" class="-mx-2 mt-2 space-y-1">
                                <li v-for="team in settings" :key="team.name">
                                    <a :href="team.href"
                                       :class="[team.current ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50', 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold']">
                                        <component :is="team.icon"
                                                   :class="[team.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'h-6 w-6 shrink-0']"
                                                   aria-hidden="true"/>
                                        <span class="truncate">{{ team.name }}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden">
            <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" @click="sidebarOpen = true">
                <span class="sr-only">Open sidebar</span>
                <Bars3Icon class="h-6 w-6" aria-hidden="true"/>
            </button>
        </div>

        <main class="py-10 lg:pl-72">

            <v-billing-limit-warning></v-billing-limit-warning>

            <div class="mx-auto px-4 sm:px-6 md:px-8">
                <h1 class="text-2xl font-semibold text-gray-900">
                    <slot name="title"></slot>
                </h1>
            </div>

            <div class="px-4 sm:px-6 lg:px-8">
                <div class="py-4">
                    <slot name="content-without-pad"></slot>

                    <div v-if="slots.default" class="bg-white shadow sm:rounded-lg">
                        <div class="px-4 py-5 sm:p-6">
                            <slot></slot>
                        </div>
                    </div>

                </div>
            </div>
        </main>
        <v-notification></v-notification>
    </div>
</template>

<script>
import {ref} from 'vue'
import {Dialog, DialogOverlay, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {
    ArrowLeftOnRectangleIcon,
    Bars3Icon,
    CreditCardIcon,
    HomeIcon,
    UserIcon,
    UsersIcon,
    XCircleIcon
} from '@heroicons/vue/24/outline'
import {useSlots} from 'vue'
import VBillingLimitWarning from "@/scripts/components/app/VBillingLimitWarning.vue";
import useLoading from "@/scripts/store/loading";

const navigation = [
    {name: 'Обзор', href: '/dashboard', icon: HomeIcon, current: true},
    {name: 'QR коды', href: '/qrcodes', icon: UsersIcon, current: false},
]

const settings = [
    {name: 'Аккаунт', href: '/account', icon: UserIcon, current: false},
    {name: 'Биллинг', href: '/billing', icon: CreditCardIcon, current: false},
    {name: 'Выйти', href: '/account/logout', icon: ArrowLeftOnRectangleIcon, current: false},
]

export default {
    components: {
        VBillingLimitWarning,
        Dialog,
        DialogOverlay,
        TransitionChild,
        TransitionRoot,
        Bars3Icon,
        XCircleIcon,
    },

    setup() {
        const sidebarOpen = ref(false)

        navigation.forEach(item => {
            item.current = window.location.href.indexOf(item.href) > -1;
        })

        settings.forEach(item => {
            item.current = window.location.href.indexOf(item.href) > -1;
        })

        const slots = useSlots()
        const loading = useLoading();

        return {
            navigation,
            sidebarOpen,
            settings,
            slots,
            loading
        }
    },
}
</script>
